import { defineMessages } from "react-intl";

// return translations
export class BankwireHelper {
  static bankwireTranslations() {
    const I18n = defineMessages({
      amount: {
        id: "cashier-amount",
      },
      comments: {
        id: "cashier-notes",
      },
      name: {
        id: "cashier-name",
      },
      bankName: {
        id: "cashier-bank-name",
      },
      bankAddress: {
        id: "cashier-bank-address",
      },
      iban: {
        id: "cashier-IBAN",
      },
      accountNumber: {
        id: "cashier-bank-account-number",
      },
      sortCode: {
        id: "cashier-sort-code",
      },
      swiftCode: {
        id: "cashier-swift-bic-code",
      },
      otherCode: {
        id: "cashier-other-codes",
      },
      otherNotes: {
        id: "cashier-any-other-notes",
      },
      intermediaryBankName: {
        id: "cashier-intermediarybank-name",
      },
      intermediaryBankAddress: {
        id: "cashier-intermediarybank-address",
      },
      intermediarySwiftCode: {
        id: "cashier-intermediary-SWIFT",
      },
    });
    return I18n;
  }
}
